import Choices from 'choices.js';
import merge from 'deepmerge';

export default class ChoicesFactory {
    static create(el, selector, options = {}) {
        this.options = merge({
            removeItemButton: true,
            itemSelectText: '',
            renderChoiceLimit: -1,
            searchResultLimit: 4,
            noResultsText: 'Aucun résultat',
            noChoicesText: 'Aucun choix',
            fuseOptions: {
                threshold: 0,
                location: 0,
                distance: 50,
            },
        }, options);

        const choicesElements = [...el.querySelectorAll(selector)];

        return choicesElements.map((choiceEl) => {
            const choices = new Choices(choiceEl, this.options);

            choices.setChoiceByValue(choiceEl.getAttribute('data-choice-value'));

            return choices;
        });
    }
}
